// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__3lvVS","row":"style_row__gx2QT","title":"style_title__27f9a","outlined":"style_outlined__4kjkm"};